import { memo } from "react";
import { formatCurrency } from "helpers";
import { InvoiceIncomingTotalProps } from "./types";

const InvoiceIncomingTotal: React.FC<InvoiceIncomingTotalProps> = ({ invoice }) => {
  const totalWithoutTax = invoice.totalWithoutTax ?? 0;
  const totalTax = invoice.totalTax ?? 0;
  const total = invoice.total ?? 0;
  const totalPaid = invoice.totalPaid ?? 0;
  const remainingAmount = invoice.remainingAmount ?? 0;
  const paidPercentage = total > 0 ? Math.min((totalPaid / total) * 100, 100) : 0;

  return (
    <div className="flex justify-end">
      <div className="w-[400px] px-3 pb-3.5">
        <div className="py-2.5 space-y-1.5 bg-white rounded-t-sm border border-slate-200 overflow-hidden">
          <div className="flex justify-between text-sm text-slate-600 px-4">
            <span>Ukupno bez PDV-a:</span>
            <span className="font-medium tabular-nums">{formatCurrency.format(totalWithoutTax)}</span>
          </div>
          <div className="flex justify-between text-sm text-slate-600 px-4">
            <span>PDV:</span>
            <span className="font-medium tabular-nums">{formatCurrency.format(totalTax)}</span>
          </div>
          <div className="flex justify-between text-sm text-slate-900 font-medium pt-1.5 border-t border-slate-200 px-4">
            <span>Ukupno s PDV-om:</span>
            <span className="tabular-nums">{formatCurrency.format(total)}</span>
          </div>
        </div>

        <div className="px-4 pt-2 pb-2.5 bg-sky-50 border-x border-b border-slate-200 flex justify-between items-center rounded-b-sm">
          <span className="text-sm font-semibold text-sky-800">Za plaćanje:</span>
          <span className="text-md font-semibold text-sky-700 tabular-nums">{formatCurrency.format(total)}</span>
        </div>

        {/* Prikaz uplata */}
        {totalPaid > 0 && (
          <div className="mt-2 border border-slate-200 rounded-sm overflow-hidden">
            {/* Progress bar */}
            <div className="h-1.5 bg-slate-100">
              <div
                className={`h-full transition-all duration-300 ${paidPercentage >= 100 ? "bg-green-500" : "bg-amber-500"}`}
                style={{ width: `${paidPercentage}%` }}
              />
            </div>

            <div className="py-2 px-4 space-y-1">
              <div className="flex justify-between text-sm">
                <span className="text-green-600">Uplaćeno:</span>
                <span className="font-medium tabular-nums text-green-600">{formatCurrency.format(totalPaid)}</span>
              </div>
              {remainingAmount > 0 && (
                <div className="flex justify-between text-sm">
                  <span className="text-amber-600">Preostalo:</span>
                  <span className="font-medium tabular-nums text-amber-600">{formatCurrency.format(remainingAmount)}</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(InvoiceIncomingTotal);
